import { colorStyleList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ColorStyle() {
  return (
    <section id="styles" className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-5">
            <SectionHeading
              align="left"
              eyebrow="画风解析"
              title="全彩、黑白还是半彩？先认清画面的呈现方式"
              desc="上色方式直接决定阅读观感。同样是「彩色漫画」，整幅全彩与关键页点彩给人的感受完全不同；而印刷版的墨线黑白，又提供了另一种更依赖分镜的节奏。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-information-line text-secondary-600"></i>
                “无遮挡 / 完整度”该怎么理解
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                这一说法描述的是分镜与画面处理的完整程度，即内容是否经过明显裁切或遮盖、页面是否连贯。
                它并不等同于内容分级，具体作品的呈现仍以你选择的阅读来源标注为准。本站只做中性说明，不对作品内容作评价。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {colorStyleList.map((item) => (
              <article
                key={item.name}
                className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-accent-300 transition-colors"
              >
                <span className="w-11 h-11 rounded-lg flex items-center justify-center bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}